<!--
 * @Author: chenxing
 * @Date: 2021-04-23 14:16:12
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-08-17 15:43:56
-->
<template>
  <div class="material-cost w100 h100">
    <!-- 原UI -->
    <a-row style="display: none">
      <a-col :span="7" class="material-cost-left">
        <a-row class="material-cost-filter">
          <a-col :span="24" class="clearfix">
            <a-form-item label="上传时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" class="upload_time">
              <a-range-picker :placeholder="['开始日期', '结束日期']" separator="到" v-model:value="filterCondition.defaultValue" :format="[dateRangeFormat, dateRangeFormat]" :ranges="dateRanges" :disabled-date="disabledDate" :allow-clear="false" @change="onDateRangeChange" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" class="clearfix">
            <CalendarBox :date-arr="selectDate" :show-reset-btn="true" @onResetBtnClick="onResetBtnClick" :table-loading="tableLoading" calendar-width="100%" calendar-height="100%" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="17" class="material-cost-right">
        <a-row class="material-cost-content">
          <a-col :span="24">
            <a-config-provider :locale="localePro">
              <a-table size="small" table-layout="auto" class="material-cost-table ant-table-fixed-first-row" :data-source="materialCostData.materialCostSource" :columns="materialCostData.columns" :scroll="{ x: true, y: tableHeight }" :row-key="record => (record.deptId ? record.deptId : '')" :pagination="tablePagination" :loading="tableLoading" bordered @change="onTableChange">
                <template #cameraArr="{ record }">
                  <div v-for="(cameraObj, index) in record.cameraInformationList" :key="index" class="table-arr-box">
                    {{ cameraObj.userCode }}
                  </div>
                </template>
                <template #shotsNumArr="{ record }">
                  <div v-for="(shotsNumObj, index) in record.cameraInformationList" :key="index" class="table-arr-box">
                    {{ shotsNumObj.count }}
                  </div>
                </template>
              </a-table>
            </a-config-provider>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!-- 新UI -->
    <a-row class="filter_row w100 bcg_w">
      <a-col :span="1" style="line-height: 32px">筛选：</a-col>
      <a-col :span="6">
        <a-range-picker :placeholder="['开始日期', '结束日期']" separator="至" v-model:value="filterCondition.defaultValue" :format="[dateRangeFormat, dateRangeFormat]" :ranges="dateRanges" :disabled-date="disabledDate" :allow-clear="false" @change="onDateRangeChange" />
      </a-col>
      <a-col :span="17">
        <a-space class="float-r">
          <a-button type="primary" @click="getMaterialCostListData" :disabled="tableLoading">筛选</a-button>
          <a-button type="default" @click="resetFilter" :disabled="tableLoading">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <div class="table_wrapper w100 bcg_w">
      <a-table size="small" table-layout="auto" class="material-cost-table ant-table-fixed-first-row" :data-source="materialCostData.materialCostSource" :columns="materialCostData.columns" :scroll="{ x: true, y: tableHeight }" :row-key="record => (record.deptId ? record.deptId : '')" :pagination="tablePagination" :loading="tableLoading" bordered @change="onTableChange">
        <template #cameraArr="{ record }">
          <div v-for="(cameraObj, index) in record.cameraInformationList" :key="index" class="table-arr-box">
            {{ cameraObj.userCode }}
          </div>
        </template>
        <template #shotsNumArr="{ record }">
          <div v-for="(shotsNumObj, index) in record.cameraInformationList" :key="index" class="table-arr-box">
            {{ shotsNumObj.count }}
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import CalendarBox from '@/components/Calendar/calendarBox.vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import localePro from 'ant-design-vue/lib/locale-provider/zh_CN';
import { getMaterialCostListData } from '@/api/material/cost.js';
import { getDocumentScroll } from '@/utils/utils.js';
export default {
  components: {
    CalendarBox,
  },
  data() {
    return {
      locale,
      localePro,
      tableHeight: 1920,
      // 列表加载
      tableLoading: false,
      // 表格分页配置
      tablePagination: {
        limit: '30',
        page: '1',
        pageSize: 31,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['11', '21', '31', '51'],
      },
      // 预设的时间范围
      dateRanges: {
        昨天: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        最近三天: [moment().subtract(3, 'days'), moment().subtract(1, 'days')],
        本周: [moment().startOf('week'), moment.min(moment().subtract(1, 'days'), moment().endOf('week'))],
        最近七天: [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
        本月: [moment().startOf('month'), moment.min(moment().subtract(1, 'days'), moment().endOf('month'))],
        最近三十天: [moment().subtract(30, 'days'), moment().subtract(1, 'days')],
        最近九十天: [moment().subtract(90, 'days'), moment().subtract(1, 'days')],
      },
      // 选中的时间范围
      selectDate: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      // 时间格式
      dateRangeFormat: 'YYYY-MM-DD',
      // 筛选条件值
      filterCondition: {
        limit: '30',
        page: '1',
        defaultValue: [moment(), moment()],
        startUploadTime: moment().format('YYYY-MM-DD'),
        endUploadTime: moment().format('YYYY-MM-DD'),
      },
      // 产品数据集合
      materialCostData: {
        columns: [
          {
            title: '部门',
            width: '150px',
            dataIndex: 'deptName',
          },
          {
            title: '产出条数',
            width: '120px',
            dataIndex: 'productNum',
          },
          {
            title: '演员费用',
            width: '150px',
            dataIndex: 'allCost',
          },
          {
            title: '单条均价',
            width: '150px',
            dataIndex: 'averageCost',
          },
          {
            title: '摄像',
            width: '150px',
            dataIndex: 'cameraInformationList',
            slots: { customRender: 'cameraArr' },
          },
          {
            title: '拍摄条数',
            // width: '100px',
            dataIndex: 'cameraInformationList',
            slots: { customRender: 'shotsNumArr' },
          },
          // {
          //   title: '备注',
          //   dataIndex: 'remarks',
          //   slots: { customRender: 'remarks' },
          // },
        ],
        materialCostSource: [],
      },
    };
  },
  created() {
    // 获取素材成本列表
    this.getMaterialCostListData();
  },
  watch: {
    tableHeight(newVal) {
      this.tableHeight = newVal;
    },
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableHeight = getDocumentScroll();
      })();
    };
  },
  methods: {
    resetFilter() {
      this.filterCondition.defaultValue = [];
      this.filterCondition.startUploadTime = null;
      this.filterCondition.endUploadTime = null;
    },
    /** 获取素材成本列表
     * @param {*}
     * @return {*}
     */
    async getMaterialCostListData() {
      if (this.tableLoading === true) {
        return;
      }
      this.tableLoading = true;
      let res = await getMaterialCostListData(this.filterCondition);
      this.tableLoading = false;
      let list = res.page ? res.page.list : [];
      this.tablePagination.current = res.page?.currPage;
      this.filterCondition.pageSize = res.page?.pageSize;
      // 数据总数加上分页的总计条数
      this.tablePagination.total = res.page.totalCount + Math.ceil(res.page.totalCount / res.page.pageSize);
      this.materialCostData.materialCostSource = list;
      this.tableHeight = getDocumentScroll();
    },
    /** 设置不可选择时间
     * @param {Moment} current 点击的时间
     * @return {*}
     */
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },

    /** 开始时间结束时间选择
     * @param {*} val
     * @param {*} dateString
     * @return {*}
     */
    onDateRangeChange(val, dateString) {
      this.selectDate = dateString;
      this.filterCondition.startUploadTime = dateString[0];
      this.filterCondition.endUploadTime = dateString[1];
      this.filterCondition.current = 1;
      this.filterCondition.page = '1';
      // this.getMaterialCostListData();
    },

    /** 重置筛选
     * @param {*}
     * @return {*}
     */
    onResetBtnClick() {
      this.filterCondition = {
        limit: 10,
        page: 1,
        defaultValue: [moment(), moment()],
        startUploadTime: moment().format('YYYY-MM-DD'),
        endUploadTime: moment().format('YYYY-MM-DD'),
      };
      this.selectDate = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
      this.getMaterialCostListData();
    },

    /** 分页发生变化
     * @param {Object} pagination 分页变化后的详情
     * @param {*} filters
     * @param {*} sorter
     * @return {*}
     */
    onTableChange(pagination, filters, sorter) {
      this.tablePagination.page = '' + pagination.current;
      this.tablePagination.limit = (pagination.pageSize - 1).toString();
      this.filterCondition.limit = (pagination.pageSize - 1).toString();
      this.tablePagination.pageSize = pagination.pageSize;
      this.filterCondition.pageSize = pagination.pageSize;
      this.filterCondition.page = '' + pagination.current;
      this.getMaterialCostListData();
    },
  },
};
</script>
<style lang="less" scoped>
.material-cost {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  :deep(.ant-calendar-picker-input) {
    height: 32px;
  }
  .upload_time {
    align-items: center;
    :deep(.ant-col-6) {
      text-align: left;
      padding-bottom: 0;
    }
  }
  .material-cost-left {
    padding-right: 1.7rem;
  }
  .material-cost-add {
    margin: 1em 2em;
  }
  .material-cost-content {
    .table-arr-box {
      margin: -8px;
      padding: 4px 8px;
      margin-top: 8px;
    }
    .table-arr-box:first-child {
      margin-top: -8px;
    }
    .table-arr-box + .table-arr-box {
      border-top: 1px solid #f0f0f0;
    }
    .remark-box {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-right: -42px;
    }
  }
  .ant-row.ant-form-item {
    margin-bottom: 8px;
  }
  .ant-table-fixed-first-row :deep(table) tbody tr:nth-child(1) td {
    background: #fff;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
  }
}
</style>